"use strict";

var React = require("react");

var config = require("./config");
var classNames = require("classnames");
var createClass = require("create-react-class");
var scriptLoader = require("load-script");

module.exports = function (scope) {
  return createClass({
    componentDidMount: function componentDidMount() {
      var t = this;
      if (window.DemoUpPlayerRenderer) {
        window.DemoUpPlayerRenderer(t.$container, t.props);
      } else {
        scriptLoader(config.playerRenderer(scope), function () {
          window.DemoUpPlayerRenderer && window.DemoUpPlayerRenderer(t.$container, t.props);
        });
      }
    },

    componentWillUnmount: function componentWillUnmount() {
      var CrossCustomEvent = require("customevent");
      document.dispatchEvent(new CrossCustomEvent("demoup.unmounted"));
    },

    setRef: function setRef(node) {
      this.$container = node;
    },

    render: function render() {
      return React.createElement("div", {
        className: classNames("demoup-player", this.props.className),
        ref: this.setRef
      });
    }
  });
};